import React from 'react';
import {MASTER_DATA_ACTION} from "ubs-framework/v2/common/constant";

const initialState = {
    socketId: '',
    orgId: '',
    subCompanyList: [],
    branchList: [],
    departmentList: [],
    subDepartmentList: [],
    subLocationList: [],
    categoryList: [],
    shiftList: [],
    jobTitleList: [],
    employeeStatusList: [],
    sourceListsourceList: [],

    businessUnitList: [],
    costCenterList: [],
    bandList: [],
    segmentList: [],
    hubList: [],
    territoryList: [],
    regionList: [],
    gradeList: [],
    workAreaList: [],
    jobList: [],
    familyInfo: [],
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION': {
            return {...state, socketId: action.payload};
        }
        case 'AUTHENTICATE': {
            const data = {}
            if (action.payload) data.orgId = action.payload.orgId
            return {...state, ...data};
        }
        case 'GET_ATS_MASTER_DATA': {
            const subCompanyList = JSON.parse(JSON.stringify(state.subCompanyList))
            action.payload?.subCompanyList?.forEach(e => subCompanyList.push({...e, label: e?.company, value: e?._id}))
            return {
                ...state,
                subCompanyList: subCompanyList.filter((v, i, a) => a.findIndex(t => (t._id === v._id)) === i).sort((a, b) => (a?.label || '').localeCompare(b?.label || '')),
                shiftList: action.payload?.shiftList,
                branchList: (action?.payload?.branchList?.map(e => ({...e, label: e.name, value: e._id})) || []).sort((a, b) => (a?.name || '').localeCompare(b?.name || '')),
                subDepartmentList: (action.payload.subDepartmentList || []).sort((a, b) => (a?.name || '').localeCompare(b?.name || '')),
                subLocationList: (action?.payload?.subLocationList?.map(e => ({...e, label: e.name, value: e._id})) || []).sort((a, b) => (a?.name || '').localeCompare(b?.name || '')),
                categoryList: (action?.payload?.categoryList?.map(e => ({...e, label: e.name, value: e._id})) || []).sort((a, b) => (a?.name || '').localeCompare(b?.name || '')),
                departmentList: (action?.payload?.departmentList?.map(e => ({...e, label: e.name, value: e._id})) || []).sort((a, b) => (a?.name || '').localeCompare(b?.name || '')),
                jobTitleList: (action?.payload?.jobTitleList?.map(e => ({...e, label: e.name, value: e._id})) || []).sort((a, b) => (a?.name || '').localeCompare(b?.name || '')),
                employeeStatusList: (action?.payload?.employeeStatusList?.map(e => ({...e, label: e.name, value: e._id})) || []).sort((a, b) => (a?.name || '').localeCompare(b?.name || '')),
                jobList: action?.payload?.jobList?.map(e => ({...e, label: e.name, value: e._id})),
                sourceList: action.payload.sourceList,
                familyInfo: (action.payload.familyInfo?.map(e => ({...e, label: e.name, value: e._id})) || []).sort((a, b) => (a?.name || '').localeCompare(b?.name || '')),
            };
        }
        case "SET_ORG_STRUCTURE" : {
            if(action.payload?.type === "set"){
                return {
                    ...state,
                    businessUnitList: action.payload?.data?.businessUnitList || [],
                    costCenterList: action.payload?.data?.costCenterList || [],
                    bandList: action.payload?.data?.bandList || [],
                    segmentList: action.payload?.data?.segmentList || [],
                    hubList: action.payload?.data?.hubList || [],
                    territoryList: action.payload?.data?.territoryList || [],
                    regionList: action.payload?.data?.regionList || [],
                    gradeList: action.payload?.data?.gradeList || [],
                    workAreaList: action.payload?.data?.workAreaList || [],
                }
            }else{
                return state;
            }
        }
        case 'SET_WORKSPACE_LIST': {
            const localState = {};
            const subCompanyList = JSON.parse(JSON.stringify(state.subCompanyList));
            if (action.payload?.length) {
                const data = action.payload.find(e => e.orgId === state.orgId);
                if (data) {
                    subCompanyList.unshift({
                        ...data,
                        label: data.company,
                        value: data._id
                    });
                }
                localState.subCompanyList = subCompanyList.filter((v, i, a) => a.findIndex(t => (t._id === v._id)) === i).sort((a, b) => (a?.label || '').localeCompare(b?.label || ''));
            }
            return {...state, ...localState};
        }
        case 'UPDATE_ATS_MASTER_DATA': {
            const key = Object.keys(action.payload?.payload)?.[0]
            const value = action.payload?.payload?.[key]
            let localState = null
            if (state[key]) localState = JSON.parse(JSON.stringify(state[key]));

            switch (action.payload.action) {
                case MASTER_DATA_ACTION.ADD : {
                    localState?.push(value)
                    break;
                }
                case MASTER_DATA_ACTION.UPDATE : {
                    localState = localState?.map(e => {
                        if (e._id === value?._id) return {...e, ...value}
                        else return e
                    })
                    break;
                }
                case MASTER_DATA_ACTION.REPLACE : {
                    localState = value
                    break;
                }
                case MASTER_DATA_ACTION.DELETE : {
                    localState = localState?.filter(e => e._id !== value?._id)
                    break;
                }
            }

            return {...state, [key]: localState};
        }
        case 'SET_FAMILY_INFO_LIST':
            return {...state, familyInfo: action.payload};
        default: {
            return state;
        }
    }
}
